module.exports = __webpack_public_path__ + "static/media/3especias gde.9e4326d8.png";